import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import AceEditor from "react-ace";
import { useTheme } from '@material-ui/core/styles';
import LoadingIndicator from '../../common/LoadingIndicator';

interface Props {
  logs: string;
  onClose: () => void;
}

function DeploymentLogsDialog(props: Props) {
  const { logs, onClose } = props;
  const theme = useTheme();

  return (
    <Dialog
      open={true}
      scroll="paper"
      onClose={onClose}
      aria-labelledby="test-logs-dialog-title"
      aria-describedby="test-logs-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle disableTypography>
        <Typography variant="h6" color="primary">Deployment Logs</Typography>
      </DialogTitle>
      <DialogContent>
        {logs && <div>
          <AceEditor
            readOnly
            wrapEnabled
            mode="powershell"
            theme={theme.palette.type === 'light' ? 'github' : 'monokai'}
            width="100%"
            minLines={20}
            maxLines={Infinity}
            value={logs}
            setOptions={{ useWorker: false, showGutter: false, highlightActiveLine: false }}
            showPrintMargin={false}
            editorProps={{ $blockScrolling: true }}
          />
        </div>}
        {!logs && <LoadingIndicator loading={true} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeploymentLogsDialog;
